import { Cell, Pie, PieChart, ResponsiveContainer } from "recharts";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface Zone {
  color: string;
  label: string;
  bg: string;
}

export function getZone(ratio: number): Zone {
  if (ratio < 0.15) {
    return { color: "hsl(142 76% 36%)", label: "Saludable", bg: "bg-green-100 text-green-800" };
  }
  if (ratio <= 0.30) {
    return { color: "hsl(45 93% 47%)", label: "Precaucion", bg: "bg-yellow-100 text-yellow-800" };
  }
  return { color: "hsl(0 72% 51%)", label: "Alto", bg: "bg-red-100 text-red-800" };
}

const ZONES: Array<{ max: number; color: string; label: string }> = [
  { max: 15, color: "hsl(142 76% 36%)", label: "< 15%" },
  { max: 30, color: "hsl(45 93% 47%)", label: "15-30%" },
  { max: 100, color: "hsl(0 72% 51%)", label: "> 30%" },
];

interface CeremonyTaxGaugeProps {
  ratio: number;
}

export function CeremonyTaxGauge({ ratio }: CeremonyTaxGaugeProps) {
  const zone = getZone(ratio);
  const pct = Math.round(ratio * 100);
  const filled = ratio * 100;
  const empty = 100 - filled;

  const data = [
    { name: "filled", value: filled },
    { name: "empty", value: empty },
  ];

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium">Ceremony Tax</CardTitle>
      </CardHeader>
      <CardContent>
        <div
          role="img"
          aria-label={`Ceremony Tax: ${pct}%`}
          className="flex flex-col items-center"
        >
          <ResponsiveContainer width="100%" height={140}>
            <PieChart>
              <Pie
                data={data}
                dataKey="value"
                startAngle={180}
                endAngle={0}
                innerRadius="60%"
                outerRadius="90%"
                paddingAngle={0}
                isAnimationActive={false}
              >
                <Cell fill={zone.color} />
                <Cell fill="hsl(210 20% 93%)" />
              </Pie>
            </PieChart>
          </ResponsiveContainer>

          {/* Percentage text overlaid on gauge center */}
          <div className="-mt-16 text-center">
            <span className="text-2xl font-bold">{pct}%</span>
          </div>

          {/* Status badge */}
          <div className="mt-3">
            <span className={`inline-block rounded-full px-3 py-0.5 text-xs font-medium ${zone.bg}`}>
              {zone.label}
            </span>
          </div>

          {/* Three-zone legend */}
          <div className="flex gap-3 mt-3">
            {ZONES.map((z) => (
              <div key={z.label} className="flex items-center gap-1 text-xs text-muted-foreground">
                <span
                  className="inline-block h-2 w-2 rounded-full"
                  style={{ backgroundColor: z.color }}
                />
                {z.label}
              </div>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
